import _, { isArray } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Checkbox, Grid, Accordion, AccordionDetails, AccordionSummary, Box, LinearProgressProps, Typography, MenuItem, Select, FormControl, InputLabel, FormControlLabel } from '@mui/material';
import { City, EAPSectoralSectors, Industry, Province, Suburb, EESectoralTargetYears, BargainingCouncil } from '../../../Component/Model/Dto/StaticData';
import { StaticDataService } from '../../../Component/Api/StaticData/StaticDataService';
import { SubmitHandler, useForm } from 'react-hook-form';
import { BusinessTypeDictionary, NumberOfEmployeesDictionary } from '../../../Component/Model/Dictionary/StaticDataDictionary';
import PublishIcon from '@mui/icons-material/Publish';
import { defaultObject, isNullOrEmpty, MapAddressDtoOutToIn } from "../../../Component/Model/helpers";
import { EEScorecard } from '../../../Component/Model/Dto/EmploymentEquity/EEScorecard';
import { EEScorecardService } from '../../../Component/Api/EmploymentEquity/Scorecard/EEScorecardService';
import { toast } from 'react-toastify';
import { eeModule, portal } from '../../../Component/Common/Constants/routes';
import * as EEScorecardActions from '../../../Component/Common/Constants/EEScorecard.Actions';
import { eeGeneralInformationSchema } from './GeneralInformationForm';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';
import { getProvinceLookup } from '../../Common/StaticData/Province';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ScorecardAtom } from '../../../State/Scorecard.Atom';
import { MDProgress } from '../../../Component/Common/Components/MDProgress';
import { UserAtom } from '../../../State/user.Atom';
import AppSelectList, { IDropDownOptions } from '../../../Component/Common/Components/FormValidationInputs/AppSelectList';
import { setaClassificationList, YesNoList } from '../../../Component/Common/Constants/Lists/DropdownListOptions';
import { yupResolver } from '@hookform/resolvers/yup';
import AppTextInput from '../../../Component/Common/Components/FormValidationInputs/AppTextInput';
import { AppDatepicker } from '../../../Component/Common/Components/FormValidationInputs/AppDatepicker';
import AppAutoComplete from '../../../Component/Common/Components/FormValidationInputs/AppAutoComplete';
import { LoadingButton } from '@mui/lab';
import { EESectoralTargetYears as SectoralTargetYears } from '../../../Component/Model/Enum/EmploymentEquity';
import { EEScorecardAtom } from '../../../State/EEScorecard.Atom';
import dayjs from 'dayjs';
import { getDateWithoutTime } from '../../../Helpers/DateFormatter';
import {useSignalRConnection} from "../../../Hooks/useSignalRConnection";
import { ConfirmationDialog } from '../../../Component/Common/Components/ConfirmationDialog';
import { MDButton } from '../../../Component/Common/Components/MDButton';
import { UserActivityService } from '../../../Component/Api/UserActivity/UserActivityService';
import { GeneralInformationSection } from '../../../Component/Common/Constants/UserActivityTrackingSections';
import { UserActivityActionType } from '../../../Component/Model/Enum/BEE123Enums';

export function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <MDProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

interface IProps {
    previous?: (scorecardId: string) => void;
    startConsolidation?: (scorecardId: string) => void;
    scorecardLicenseId?: string;
    isConsolidationScorecard: boolean;
    scorecardName?: string;
    fromDate?: Date;
    toDate?: Date;
}

export const GeneralInformation = (props: IProps) => {
    const location = useLocation<any>();
    const history = useHistory();
    const scorecard = useRecoilValue(ScorecardAtom);
    const [eeScorecard, setEEScorecard] = useRecoilState(EEScorecardAtom);
    const [ApplicableScorecards, setApplicableScorecards] = useState<EEScorecard.CopyDtoOut[]>(defaultObject);
    const [selectedApplicableScorecard, setSelectedApplicableScorecard] = React.useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const User = useRecoilValue(UserAtom);
    const hub = useSignalRConnection("ScorecardCopyHub");
    const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
    const confirmConsolidationMessage = 'Please note that if you consolidate, the different sections of your scorecard will be updated or remain unchanged according to the consolidation rules you configured and the notes specified. Are you sure you want to continue?';
    const confirmReconsolidationMessage = 'Please note that if you reconsolidate/update your Consolidated Scorecard, all the data will be deleted and replaced with updated data from the selected source scorecards. Are you sure you want to continue?';
    
    const eeYearOptions: IDropDownOptions[] =
        [
            { value: "1 Year", id: 1 },
            { value: "2 Years", id: 2 },
            { value: "3 Years", id: 3 },
            { value: "4 Years", id: 4 },
            { value: "5 Years", id: 5 }
        ]

    const getYearFromDate = (year: number, date?: Date) => {

        let yearFromDate = getDateWithoutTime(new Date());
        if (date != null && date !== undefined) {
            yearFromDate = date;
        }
        yearFromDate.setFullYear(yearFromDate.getFullYear() + year);
        yearFromDate.setDate(yearFromDate.getDate() - 1);
        return yearFromDate;
    }

    //form
    // eslint-disable-next-line 
    const { handleSubmit, control, setValue, reset, getValues } = useForm({
        mode: 'all',
        resolver: yupResolver(eeGeneralInformationSchema)
    });

    const [formAction, setFormAction] = React.useState("");

    //Disbaled input checks
    const [usePhysicalAddress, setUsePhysicalAddress] = React.useState(false);
    const [isGroup, setIsGroup] = React.useState(false);

    //Api general data
    const [cities, setCities] = React.useState<City[]>([]);
    const [suburbs, setSuburbs] = React.useState<Suburb[]>([]);
    const [provinces, setProvinces] = React.useState<Province[]>([]);
    const [industries, setIndustries] = React.useState<Industry[]>([]);
    const [bargainingCouncils, setBargainingCouncils] = React.useState<BargainingCouncil[]>([]);

    const [appliedEapOptions, setAppliedEapOptions] = React.useState<IDropDownOptions[]>([]);
    const [applicableEapYear, setApplicableEapYear] = React.useState<IDropDownOptions[]>([]);
    const [applicableSectoralTargetYearOptions, setApplicableSectoralTargetYearOptions] = React.useState<EESectoralTargetYears[]>([]);
    const [appliedSectoralOptions, setAppliedSectoralOptions] = React.useState<EAPSectoralSectors[]>([]);
    const [Progress, setProgress] = React.useState(0);
    const [hideCheckbox, setHideCheckbox] = React.useState(false);

    const getSuburbs = async () => {
        try {
            const suburbsResponse = await StaticDataService.getSuburbs();
            setSuburbs(suburbsResponse.data);
        } catch (error) {
            console.log(error);
        }
    }

    const getCities = async () => {
        try {
            const cityResponse = await StaticDataService.getCities();
            setCities(cityResponse.data);
        } catch (error) {
            console.log(error);
        }
    }

    const getProvinces = async () => {
        try {
            const provincesResponse = await StaticDataService.getProvinces();
            setProvinces(provincesResponse.data);
        } catch (error) {
            console.log(error);
        }
    }
  
    const getBargainingCouncils = async (bargainingCouncil: number | null) => {
        try {
            const bargainingCouncilsResponse = await StaticDataService.getBargainingCouncils();
            setBargainingCouncils(bargainingCouncilsResponse.data);

            if (!isNullOrEmpty(bargainingCouncil)){
                setValue("BargainingCouncil", bargainingCouncilsResponse.data.filter(data => data.Id === bargainingCouncil)[0]);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getIndustries = async () => {
        try {
            const industriesResponse = await StaticDataService.getIndustries();
            setIndustries(industriesResponse.data);
        } catch (error) {
            console.log(error);
        }
    }

    const getAppliedEapOptions =  () => {
        const appliedEapAndSectoralOptions = getProvinceLookup();
        setAppliedEapOptions(appliedEapAndSectoralOptions);
    }

    const getApplicableEapYears = async () => {
        try {
            const result = await StaticDataService.getApplicableEapYears();
            const eAPYearsMapped = result.data.map((year) => ({
                        id: year,  
                        value: year.toString(),
                    }));
            setApplicableEapYear(eAPYearsMapped);

        } catch (error) {
            console.log(error)
        }
    };

    const getEAPSectoralOptions = async (appliedSectoralPercentage: number | null | undefined) => {
        try {
            const sectoralResponse = await StaticDataService.getEAPSectoralSectors();
            setAppliedSectoralOptions(sectoralResponse.data);
            if (!isNullOrEmpty(appliedSectoralPercentage) && appliedSectoralPercentage !== 0){
                setValue("AppliedSectoralPercentage", sectoralResponse.data.filter(data => data.Id === appliedSectoralPercentage)[0]);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getApplicableSectoralTargetYearOptions = async (year: number | undefined) => {
        try {
            const yearResponse = await StaticDataService.getEESectoralTargetYears();
            setApplicableSectoralTargetYearOptions(yearResponse.data);
            if(year !== null){
                setValue("ApplicableSectoralTargetYear", yearResponse.data.filter(data => data.Id === year)[0]);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getGeneralInfo = async (id: string) => {
        try {
            const generalInfoResponse = await EEScorecardService.GetEEGeneralInfo(id);
            const generalInfo = generalInfoResponse.data;
            const generalInfoFormData = {
                ...generalInfo,
                "BusinessType": BusinessTypeDictionary.filter(data => data.Id === generalInfo.BusinessTypeId)[0],
                "NumberOfEmployees": NumberOfEmployeesDictionary.filter(data => data.Id === generalInfo.NumberOfEmployeesId)[0],
                "AppliedSectoralPercentage": null,
                "ApplicableSectoralTargetYear": {Id: 1, Name: ''},
                "YearReportIsSubmitted": dayjs().year(generalInfo.YearReportIsSubmitted).startOf('year'),
                "ApplicableEAPYear": generalInfo.ApplicableEAPYear ?? generalInfo.YearReportIsSubmitted,
                "IsOrganOfState": Number(generalInfo.IsOrganOfState),
                "IsGroup": Number(generalInfo.IsGroup),
                "BargainingCouncil": null
            }
            setEEScorecard(generalInfoResponse.data);
            getEAPSectoralOptions(generalInfo.AppliedSectoralPercentage);
            getApplicableSectoralTargetYearOptions(generalInfo.ApplicableSectoralTargetYear);
            getBargainingCouncils(generalInfo.BargainingCouncil);
            setIsGroup(generalInfo.IsGroup);
            setUsePhysicalAddress(generalInfo.IsPostalSameAsPhysical ? generalInfo.IsPostalSameAsPhysical : false);
            reset(generalInfoFormData);
            getConsolidatedScorecardEEPlanSources(id);
        } catch (error: any) {
            console.log(error);
        }
    }

    const getConsolidatedScorecardEEPlanSources = async (scorecardId: string) => {
        try {
            const result = await EEScorecardService.GetConsolidationRulesMap(scorecardId);
            const sourceScorecardsCount = result.data.sourceScorecardIds?.length ?? 0;

            if (sourceScorecardsCount > 0) {
                setEEScorecard(prevScorecard => ({
                ...prevScorecard,
                ConsolidationSourceScorecardsCount: sourceScorecardsCount,
                }));
            }
        } 
        catch (error) {
            console.log(error)
        }  
    }

    const generalInformationLog = (actionType: number, actionDescription: string) => {
        UserActivityService.createActivityLog({
            section: GeneralInformationSection,
            actionType: actionType,
            actionDescription: actionDescription,
            scorecardId: scorecard.scorecardId,
            requestUrl: window.location.href
        });
    }

    useEffect(() => {
        let scorecardId = scorecard.scorecardId;

        try {
            if (location.state == null && scorecardId != null) {
                setFormAction(EEScorecardActions.update);
                getGeneralInfo(scorecardId);
            }
            else if (location.state.action === EEScorecardActions.create && location.state.scorecardLicenseId) {
                setFormAction(EEScorecardActions.create);
                reset({
                    "ScorecardLicenseId": props.isConsolidationScorecard ? props.scorecardLicenseId : location.state.scorecardLicenseId,
                    "EEPlanDateFrom": getDateWithoutTime(new Date()),
                    "EEPlanDateTo": getYearFromDate(5),
                    "EEPlanYears": 5,
                    "WorkforceProfileSnapshotDate": getDateWithoutTime(new Date()),
                    "ScorecardName": props.scorecardName ?? '',

                    ...(props.isConsolidationScorecard && {
                        "ReportPeriodDateFrom": getDateWithoutTime(props.fromDate ?? new Date()),
                        "ReportPeriodDateTo": getDateWithoutTime(props.toDate ?? getYearFromDate(5)),
                    }),
                });
                getEAPSectoralOptions(null);
                getApplicableSectoralTargetYearOptions(SectoralTargetYears.Final_Targets_2025);
                getBargainingCouncils(null);
            }
        } catch (error: any) {
            history.push(`/ee/base`);
        }

        getSuburbs();

        getProvinces();

        getIndustries();

        getCities();

        getAppliedEapOptions();

        getApplicableEapYears();

        generalInformationLog(UserActivityActionType.View, "View general information");
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const signalR = async (scorecardId: string, identifier: string) => {
        try {
            if (!hub.isConnected) {
                await hub.start();
            }

            hub.on(`taskStarted-${identifier}`, (percent: number) => {
                setProgress(percent);
            });

            hub.on(`taskProgressChanged-${identifier}`, (percent: number) => {
                setProgress(percent);
            });

            hub.on(`taskEnded-${identifier}`, (percent: number) => {
                setProgress(percent);
            });
        } catch (error) {
            console.error("SignalR connection failed:", error);
        }
    }

    useEffect(() => {
        if (location.state != null && location.state.action === EEScorecardActions.create) {
            getScorecardCopyFrom(location.state.scorecardLicenseId);
        }
    }, [])


    const getScorecardCopyFrom = async (ScorecardLicenseId: string) => {
        try {
            const result = await EEScorecardService.GetApplicableScorecard(ScorecardLicenseId);
            setApplicableScorecards(result.data);
        } catch (e: any) {
            console.log(e)
        }
    }

    const saveAndCopyScorecard = async (request: EEScorecard.DtoIn) => {
        try {
            setLoading(true);
            if (formAction === EEScorecardActions.update) return;
            let scorecardId = await EEScorecardService.CreateScorecard(request);
            if (scorecardId.data) {
                let copyRequest: EEScorecard.CopyDtoIn =
                {
                    consolidatedScorecardId: scorecardId.data,
                    groupName: "signalR",
                    sourceScorecardId: [selectedApplicableScorecard]
                };
                const identifier = `consolidation-${scorecardId.data}`;
                await signalR(scorecardId.data, identifier);
                EEScorecardService.CopyScorecard(copyRequest).then((response) => {
                    setProgress(100);
                    history.push(`${portal}${eeModule.ee}/${eeModule.base}`);
                    toast.success("Scorecard Copy Completed");
                }).catch((error) => {
                    console.log(error);
                    toast.error('Copy Failed. Please try again');
                    setProgress(0);
                });
            }

        } catch (e) {
            toast.error('Copy Failed. Please try again');
            setProgress(0);
            console.log(e)
        } finally {
            setLoading(false);
        }
    }

    const CleanObjectEmptyToNull = (data: any) => {
        const filteredData = _.pickBy(data, _.identity);
        return filteredData;
    }

    const consolidateOrReconsolidateScorecard = async (scorecardId: any) => {
        if (props.isConsolidationScorecard && props.startConsolidation) {
            setShowConfirmationDialog(false);

            const identifier = `consolidation-${scorecardId.data}`;
            await signalR(scorecardId.data, identifier);

            await props.startConsolidation?.(scorecardId.data);

            return;
        }
    }

    const saveGeneralInfo = async (request: EEScorecard.DtoIn) => {
        try {
            setLoading(true);
            if (!isNullOrEmpty(selectedApplicableScorecard) && formAction !== EEScorecardActions.update) {
                saveAndCopyScorecard(request);
                return;
            }
            if (formAction === EEScorecardActions.create) {
                // eslint-disable-next-line
                let scorecardId = await EEScorecardService.CreateScorecard(request);

                await consolidateOrReconsolidateScorecard(scorecardId);
                if (!props.isConsolidationScorecard) {
                    history.push(`${portal}${eeModule.ee}/${eeModule.base}`);
                    toast.success("Scorecard created");
                }
            }
            else if (formAction === EEScorecardActions.update) {
                // eslint-disable-next-line
                let scorecardId = await EEScorecardService.UpdateScorecard(request);
                const generalInfoResponseUpdated = await EEScorecardService.GetEEGeneralInfo(scorecard.scorecardId);
                setEEScorecard(generalInfoResponseUpdated.data);
                getConsolidatedScorecardEEPlanSources(scorecard.scorecardId);
                await consolidateOrReconsolidateScorecard(scorecardId);
                if (!props.isConsolidationScorecard) {
                    toast.success("General information updated");
                }
            }

        } catch (error: any) {
            console.log(error);
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
        } finally {
            setLoading(false);
            
        }
    }

    const onSubmit: SubmitHandler<any> = (data) => {
        const filteredData = CleanObjectEmptyToNull(data);
        const physicalAddress = data.PhysicalAddress ? MapAddressDtoOutToIn(data.PhysicalAddress) : null;
        const postalAddress = (data.PostalAddress && !usePhysicalAddress) ? MapAddressDtoOutToIn(data.PostalAddress) : null;
        delete filteredData['BusinessType'];
        delete filteredData['Industry'];
        delete filteredData['NumberOfEmployees'];
        const dataRequest: EEScorecard.DtoIn = {
            ...filteredData,
            "EEPlanDateFrom": data.EEPlanDateFrom,
            "EEPlanDateTo": data.EEPlanDateTo,
            "ReportPeriodDateFrom": data.ReportPeriodDateFrom,
            "ReportPeriodDateTo": data.ReportPeriodDateTo,
            "WorkforceProfileSnapshotDate": data.WorkforceProfileSnapshotDate,
            "YearReportIsSubmitted": dayjs(data.YearReportIsSubmitted).year(),
            "ScorecardName": data.ScorecardName,
            "DTIRegistrationName": data.DTIRegistrationName,
            "ScorecardLicenseId": data.ScorecardLicenseId,
            "ScorecardId": data.ScorecardId,
            "PhysicalAddress": physicalAddress,
            "PostalAddress": postalAddress,
            "IsPostalSameAsPhysical": usePhysicalAddress,
            "IsOrganOfState": data.IsOrganOfState,
            "IsGroup": data.IsGroup,
            "IndustryId": data.Industry?.Id,
            "BusinessTypeId": data.BusinessType?.Id,
            "NumberOfEmployeesId": data.NumberOfEmployees?.Id,
            "AppliedEapPercentage": data.AppliedEapPercentage as number,
            "AppliedSectoralPercentage": data.AppliedSectoralPercentage?.Id as number,
            "ApplicableSectoralTargetYear": data.ApplicableSectoralTargetYear?.Id as number,
            "ApplicableEAPYear" : data.ApplicableEAPYear,
            "BargainingCouncil": data.BargainingCouncil.Id as number
        };

        saveGeneralInfo(dataRequest);

        generalInformationLog(UserActivityActionType.Update, "Update general information");
    };

    const onError = (errors: any, e: any) => {
        for (let key in errors) {
            if (errors.hasOwnProperty(key)) {
                toast.error(errors[key].message);
            }
        }
    };

    const isApplicableScorecard = (selectedApplicableScorecard: string) => {
        if (!isNullOrEmpty(selectedApplicableScorecard)) {
            const scorecard = ApplicableScorecards.find((scorecard) => scorecard.Id === selectedApplicableScorecard);
            if (scorecard?.ScorecardType !== 'Employment Equity') {
                setHideCheckbox(true);
            } else {
                setHideCheckbox(false);
            }
        }
    }

    return (
        <Box component="form" onSubmit={handleSubmit(onSubmit, onError)}>
            <MDTypography variant='h4' fontWeight='bold' sx={{ mb: 1 }}>
                General Information
            </MDTypography>
            {/* EE Scorecard details */}
            <Accordion defaultExpanded={true}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fill: "white" }} />}
                    aria-controls="scorecardDetails"
                    id="scorecardDetails"
                    sx={{ backgroundColor: "#4d4f53" }}
                >
                    <MDTypography color="white">EE Scorecard Details</MDTypography>
                </AccordionSummary>
                <AccordionDetails sx={{ mt: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Scorecard Reference Number' name='ScorecardRefNumber' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Scorecard Name' name='ScorecardName' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppDatepicker control={control} label='Year For Which This Report Is Submitted' name='YearReportIsSubmitted' views={['year']} inputFormat='yyyy'/>
                            </Box>
                            <Box mb={2}>
                                <AppSelectList control={control} name="ApplicableEAPYear" label="Applicable EAP Year" items={applicableEapYear} size='small' treatZeroAsEmpty={false}/>
                            </Box>
                            <Box mb={2}>
                                <AppSelectList control={control} name="AppliedEapPercentage" label="Applied EAP %" items={appliedEapOptions} size='small' treatZeroAsEmpty={true}/>
                            </Box>
                            <Box mb={2}>
                                <AppAutoComplete control={control} name="ApplicableSectoralTargetYear" label="Applicable Sectoral Targets" options={applicableSectoralTargetYearOptions} limit={applicableSectoralTargetYearOptions.length} size='small'/>
                            </Box>
                            <Box mb={2}>
                                <AppAutoComplete control={control} name="AppliedSectoralPercentage" label="Applied Sectoral %" options={appliedSectoralOptions} limit={appliedSectoralOptions.length} size='small'/>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box mb={1}>
                                <MDTypography mb={2}>Reporting Period</MDTypography>
                            </Box>
                            <Box mb={2}>
                                <Grid container spacing={2}>
                                    <Grid item sm={6} md={6} lg={6}>
                                        <AppDatepicker control={control} name="ReportPeriodDateFrom" label="Report Period Date From" inputFormat='yyyy/MM/dd' />
                                    </Grid>
                                    <Grid item sm={6} md={6} lg={6}>
                                        <AppDatepicker control={control} name="ReportPeriodDateTo" label="Report Period Date To" inputFormat='yyyy/MM/dd'/>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box mb={1}>
                                <MDTypography mb={2}>Employment Equity Plan</MDTypography>
                            </Box>
                            <Box mb={2}>
                                <AppSelectList control={control} name="EEPlanYears" label="Number of Years in EE Plan" items={eeYearOptions} size='small'
                                    onChange={(value) => {
                                        if (value != null) {
                                            const date = new Date(getValues("EEPlanDateFrom"));
                                            setValue("EEPlanDateTo", getYearFromDate(value as number, date));
                                        }
                                    }} />
                            </Box>
                            <Box mb={2}>
                                <Grid container spacing={2}>
                                    <Grid item sm={6} md={6} lg={6}>
                                        <AppDatepicker control={control} name="EEPlanDateFrom" label="EE Plan Date From" inputFormat='yyyy/MM/dd'
                                            onChange={(date) => {
                                                if (date != null && date instanceof Date && !isNaN(date.getTime())) {
                                                    setValue("EEPlanDateTo", getYearFromDate(getValues("EEPlanYears") as number, date));
                                                }
                                            }} />
                                    </Grid>
                                    <Grid item sm={6} md={6} lg={6}>
                                        <AppDatepicker control={control} name="EEPlanDateTo" label="EE Plan Date To" inputFormat='yyyy/MM/dd' disabled={true} />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box mb={2}>
                                <AppDatepicker control={control} name="WorkforceProfileSnapshotDate" label="Workforce profile snapshot date" inputFormat='yyyy/MM/dd'
                                    onChange={(date) => {
                                        if (date != null) {
                                            setValue("WorkforceProfileSnapshotDate", date);
                                        }
                                    }} />
                            </Box>
                            <Box mb={2}>
                                <AppDatepicker control={control} name="FinalisedEEAnalysisDate" label="Date on which this EE analysis was finalised" inputFormat='yyyy/MM/dd' />
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {/* Employer Details */}
            <Accordion defaultExpanded={true}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fill: "white" }} />}
                    aria-controls="scorecardDetails"
                    id="scorecardDetails"
                    sx={{ backgroundColor: "#4d4f53" }}
                >
                    <MDTypography color="white">Employer Details</MDTypography>
                </AccordionSummary>
                <AccordionDetails sx={{ mt: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Trade Name' name='TradeName' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='DTI Registration Name' name='DTIRegistrationName' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='DTI Registration Number' name='DTIRegistrationNumber' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='PAYE/SARS number' name='PayeSarsNumber' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='UIF Reference Number' name='UIFReferenceNumber' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='EE Reference Number' name='EEReferenceNumber' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppSelectList control={control} name="SetaClassification" label="Seta Classification" items={setaClassificationList} size='small' treatZeroAsEmpty={true}/>
                            </Box>
                            <Box mb={2}>
                                <AppAutoComplete control={control} name="Industry" label="Industry" options={industries} size={"small"} limit={industries.length}/>
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Telephone Number' name='TelephoneNumber' size='small' />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {/* Physical */}
                            <Box mb={1}>
                                <MDTypography>Physical Address</MDTypography>
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Address Line 1' name='PhysicalAddress.AddressLine1' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Address Line 2' name='PhysicalAddress.AddressLine2' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppAutoComplete control={control} name="PhysicalAddress.Suburb" label="Suburb" options={suburbs} size={"small"} />
                            </Box>
                            <Box mb={2}>
                                <AppAutoComplete control={control} name="PhysicalAddress.City" label="City" options={cities} size={"small"} />
                            </Box>
                            <Box mb={2}>
                                <AppAutoComplete control={control} name="PhysicalAddress.Province" label="Province" options={provinces} size={"small"} />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Postal Code' name='PhysicalAddress.Code' size='small' />
                            </Box>
                            {/* Postal */}
                            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: 'center' }}>
                                <MDTypography>Postal Address</MDTypography>
                                <Box>
                                    <Checkbox
                                        value={usePhysicalAddress}
                                        checked={usePhysicalAddress}
                                        onChange={() => {
                                            setUsePhysicalAddress(!usePhysicalAddress);
                                        }} />
                                    <MDTypography
                                        variant='button'
                                        fontWeight='regular'
                                        color='text'
                                        sx={{ cursor: 'pointer', userSelect: 'none', ml: -1 }}
                                    >
                                        &nbsp;&nbsp;Same as Physical?&nbsp;
                                    </MDTypography>
                                </Box>
                            </Box>
                            {!usePhysicalAddress && <>
                                <Box mb={2}>
                                    <AppTextInput control={control} label='Address Line 1' name='PostalAddress.AddressLine1' size='small' />
                                </Box>
                                <Box mb={2}>
                                    <AppTextInput control={control} label='Address Line 2' name='PostalAddress.AddressLine2' size='small' />
                                </Box>
                                <Box mb={2}>
                                    <AppAutoComplete control={control} name="PostalAddress.Suburb" label="Suburb" options={suburbs} size={"small"} />
                                </Box>
                                <Box mb={2}>
                                    <AppAutoComplete control={control} name="PostalAddress.City" label="City" options={cities} size={"small"} />
                                </Box>
                                <Box mb={2}>
                                    <AppAutoComplete control={control} name="PostalAddress.Province" label="Province" options={provinces} size={"small"} />
                                </Box>
                                <Box mb={2}>
                                    <AppTextInput control={control} label='Postal Code' name='PostalAddress.Code' size='small' />
                                </Box>
                            </>}
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {/* Details of CEO/Accounting Officer at the time of submitting this report */}
            <Accordion defaultExpanded={true}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fill: "white" }} />}
                    aria-controls="scorecardDetails"
                    id="scorecardDetails"
                    sx={{ backgroundColor: "#4d4f53" }}
                >
                    <MDTypography color="white">Details of CEO/Accounting Officer at the time of submitting this report</MDTypography>
                </AccordionSummary>
                <AccordionDetails sx={{ mt: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Name' name='CeoName' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Surname' name='CeoSurname' size='small' />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Telephone Number' name='CeoTelephoneNumber' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Email Address' name='CeoEmail' size='small' />
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {/*Details of Employment Equity Senior Manager at the time of submitting this report*/}
            <Accordion defaultExpanded={true}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fill: "white" }} />}
                    aria-controls="scorecardDetails"
                    id="scorecardDetails"
                    sx={{ backgroundColor: "#4d4f53" }}
                >
                    <MDTypography color="white">Details of Employment Equity Senior Manager at the time of submitting this report</MDTypography>
                </AccordionSummary>
                <AccordionDetails sx={{ mt: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Name' name='SeniorManagerName' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Surname' name='SeniorManagerSurname' size='small' />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Telephone Number' name='SeniorManagerTelephoneNumber' size='small' />
                            </Box>
                            <Box mb={2}>
                                <AppTextInput control={control} label='Email Address' name='SeniorManagerEmail' size='small' />
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {/* Organisation Information */}
            <Accordion defaultExpanded={true}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fill: "white" }} />}
                    aria-controls="scorecardDetails"
                    id="scorecardDetails"
                    sx={{ backgroundColor: "#4d4f53" }}
                >
                    <MDTypography color="white">Organisation Information</MDTypography>
                </AccordionSummary>
                <AccordionDetails sx={{ mt: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Box mb={2}>
                                <AppAutoComplete control={control} name="BusinessType" label="Business Type" options={BusinessTypeDictionary} size={"small"} />
                            </Box>
                            <Box mb={2}>
                                <AppAutoComplete control={control} name="NumberOfEmployees" label="Number Of Employees" options={NumberOfEmployeesDictionary} size={"small"} />
                            </Box>
                            <Box mb={2}>
                                <AppAutoComplete control={control} name='BargainingCouncil' label='Bargaining Council' options={bargainingCouncils} size={"small"}/> 
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box mb={2} >
                                <Box mb={2}>
                                    <AppSelectList control={control} name='IsOrganOfState' label='Is your organisation an Organ of State?' items={YesNoList} treatZeroAsEmpty={false} />
                                </Box>
                                <Box mb={2}>
                                    <AppSelectList control={control} name='IsGroup' label='Is your organisation part of a group / holding company?' items={YesNoList} treatZeroAsEmpty={false}
                                        onChange={(value) => {
                                            setIsGroup(value === 1);
                                        }}
                                    />
                                </Box>
                                {isGroup && <AppTextInput control={control} label='Name of group / holding company' name='GroupName'/>}
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {(!props.isConsolidationScorecard) && (formAction === EEScorecardActions.create) && (ApplicableScorecards.length > 0) &&
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ fill: "white" }} />}
                        aria-controls="scorecardDetails"
                        id="scorecardDetails"
                        sx={{ backgroundColor: "#4d4f53" }}
                    >
                        <MDTypography color="white">Copy Scorecard</MDTypography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container>
                            <Grid item xs={6} sm={6} md={6} lg={6} p={2}>
                                <FormControl fullWidth>
                                    <InputLabel >Select Scorecard</InputLabel>
                                    <Select
                                        value={selectedApplicableScorecard}
                                        label={"Select Scorecard"}
                                        onChange={(e: any) => {
                                            isApplicableScorecard(e.target.value);
                                            setSelectedApplicableScorecard(e.target.value)

                                        }}
                                        sx={{
                                            padding: "0.75rem 0 !important",
                                            fontSize: "0.875rem"
                                        }}
                                        size={"medium"}
                                    >
                                        {ApplicableScorecards?.map((item) => (
                                            <MenuItem key={item.Id} value={item.Id}>{`${item.Name.replace("&#39;", "'")}`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6} p={2}>
                                <LinearProgressWithLabel value={Progress} />
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            }
            <Box mt={1}>
                {!props.isConsolidationScorecard && (
                    <LoadingButton type="submit" variant='contained' color="primary" endIcon={<PublishIcon />} loading={loading}>
                        Save
                    </LoadingButton>
                )}

                {props.isConsolidationScorecard && (
                    <Grid container spacing={2} pt={2}>
                        <Grid item xs={10} justifyContent={'flex-start'}>
                            <MDButton variant="gradient" color="secondary" onClick={() => { props.previous?.(scorecard.scorecardId) }}>Previous</MDButton>
                        </Grid>
                        <Grid item xs={2} justifyContent={'flex-end'}>
                            <LoadingButton variant='contained' loading={loading} color="primary" loadingPosition='end' onClick={() => setShowConfirmationDialog(true)}>
                                Start Consolidation
                            </LoadingButton>
                            <LinearProgressWithLabel value={Progress} />
                        </Grid>
                    </Grid>
                )}

                {props.isConsolidationScorecard && (
                    <ConfirmationDialog
                        showDialog={showConfirmationDialog}
                        handleAccept={handleSubmit(onSubmit, onError)}
                        handleCancel={() => setShowConfirmationDialog(false)}
                        heading={formAction === EEScorecardActions.update ? 'Confirm Reconsolidation' : 'Confirm Consolidation'}
                        message={formAction === EEScorecardActions.update ? confirmReconsolidationMessage : confirmConsolidationMessage}
                    />
                )}
            </Box>
        </Box>
    )
}

